import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CoreModule } from "./core/core.module";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
//External Modules
import {
  TranslateService,
  TranslateModule,
  TranslateLoader,
  TranslatePipe
} from "@ngx-translate/core";

//Services
import { LanguageService } from "./core/services/language/language.service";
import { StorageService } from "./core/services/storage/storage.service";
import { NavigationService } from "./core/services/navigation/navigation.service";
import { ReactiveFormsModule } from "@angular/forms";
/* 
import { GooglePlacesDirective } from "./directives/google-places.directive"; */
// import { ControlMessagesComponent } from '../app/components/control-messages/control-messages.component';

// import { MainComponent } from './modules/main/main.component';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({appId: 'ksuomestaweb'}),
    CoreModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    NgbModule.forRoot(),
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private language: LanguageService,
    private storage: StorageService,
    private translate: TranslateService,
    private navigation_: NavigationService
  ) {
    let currentLang = this.language.getLanguage();
    if (!currentLang) {
      let langArr = this.language.getLanguages();
      let browserLang = this.language.detectBrowserLang();
      if (langArr.indexOf(browserLang) == -1) {
        currentLang = langArr[0];
      } else {
        currentLang = browserLang;
      }
    }
    this.setLanguage(currentLang);
  }

  setLanguage(currentLang) {
    this.storage.setStorage("currentLanguage", currentLang);
    this.translate.use(currentLang);
    let path = this.language.getLocation().pathname.split("/").slice(2).join('/');
    let param = decodeURIComponent(this.language.getLocation().search);
    if (path) {
      this.navigation_.navigateTo(path,'',param);
      return;
    }
    this.navigation_.navigateTo("/", currentLang);
  }
}

export function createTranslateLoader(http: HttpClient) {

  return new TranslateHttpLoader(http, "../assets/i18n/", ".json");
}
